import React from 'react';
import { Button, Container, Modal, ModalContent, ModalHeader } from 'semantic-ui-react';
import { withRouter, RouteComponentProps } from 'react-router-dom';

interface ThankYouModalProps extends RouteComponentProps {
  header?: string;
  openedThankYouModal: boolean;
  onClose: () => void;
  navigateToAfterClose: string;
  projectUrl?: string;
}

class ThankYouModal extends React.Component<ThankYouModalProps> {
  private closeModal = (event: React.MouseEvent<HTMLButtonElement>): void => {
    event.preventDefault();
    
    const { navigateToAfterClose, projectUrl, history } = this.props;
    
    if (navigateToAfterClose === '/profile/update' && projectUrl) {
      // Navigate with state - projectUrl won't appear in URL
      history.push(navigateToAfterClose, { 
        projectUrl 
      });
    } else {
      // For other routes, navigate normally
      if (navigateToAfterClose.startsWith('http')) {
        // External URL
        window.location.href = navigateToAfterClose;
      } else {
        // Internal route
        history.push(navigateToAfterClose);
      }
    }
  }

  render(): React.ReactNode {
    const { openedThankYouModal, onClose, header, navigateToAfterClose, children } = this.props;
    
    return (
      <Container>
        <Modal 
          open={openedThankYouModal} 
          onClose={onClose}
        >
          <ModalHeader>{header}</ModalHeader>
          <ModalContent>
            <Modal.Description>
              {children}
            </Modal.Description>
          </ModalContent>
          <Modal.Actions>
            <Button 
              primary 
              onClick={this.closeModal}
            >
              {navigateToAfterClose === '/profile/update' ? 'Create Account Profile' : 'OK'}
            </Button>
          </Modal.Actions>
        </Modal>
      </Container>
    );
  }
}

export default withRouter(ThankYouModal);